export default __webpack_public_path__ + "static/media/checked-box.696ecde1.svg";